import { userAgent } from 'utils/user-agent';

export const isWebKit = () => userAgent().layout === 'WebKit';
